<rk-sidenav-action-wrapper
  [title]="'PLAYLIST.ADD_TRACKS.TITLE' | translate"
  (cancelled)="closePanel()"
  [hideBottom]="true"
  [enableScrollbar]="false"
  class="playlist-add-tracks"
>
  <div class="filter-tracks">
    <rk-search-bar type="full" (inputted)="onChangeSearch($event)"></rk-search-bar>
    <rk-box-filter
      [selectedBox]="selectedBox.value"
      (selectBox)="selectBox($event)"
    ></rk-box-filter>
  </div>
  <div class="track-title" translate>PLAYLIST.ADD_TRACKS.TRACKS</div>
  <div
    class="tracks cdk-custom-container flex"
    *ngIf="(tracks$ | async).length; else searchEmpty"
  >
    <cdk-virtual-scroll-viewport
      itemSize="60"
      class="flex-1"
      minBufferPx="800"
      maxBufferPx="1000"
    >
      <div
        class="track"
        *cdkVirtualFor="
          let track of tracks$ | async;
          let i = index;
          templateCacheSize: 60
        "
      >
        <rk-playlist-add-track-line
          class="track"
          [track]="track"
          [first]="i === 0"
          [isPlaying]="isPlaying$ | async"
          [isLoaded]="(currentTrackPlaying$ | async)?.id === track.id"
        ></rk-playlist-add-track-line>
      </div>
    </cdk-virtual-scroll-viewport>
  </div>
  <ng-template #searchEmpty>
    <div class="search-empty">
      <img src="/assets/search-empty.svg" alt="" />
      <div>
        {{ 'MEDIA.TABLE.SEARCH_EMPTY' | translate: { search: searchSubject.getValue() } }}
      </div>
    </div>
  </ng-template>
</rk-sidenav-action-wrapper>
